import { RECURRENCE_PATTERN } from '../../_shared/recurring-form/recurring-form.models';
import { CONTRIBUTION_TYPE } from '../constants/Contribute';
import { COUNTRY_NAMES } from '../constants/countries';
import FundTypes from '../constants/fund-types';
import { PaymentStatus } from '../constants/Payment';
import Urls from '../constants/urls';
import StorageHelper from '../helpers/storage.helper';

export interface PaymentResponseDto {
  amount: number;
  cseg5: string;
  balance?: number;
  entityName?: string;
  paymentId: string;
  status: string;
  email: string;
  currencySymbol?: string;
  link: string;
}

export class PaymentResponse {
  amount: number;
  balance: number;
  contributionType: CONTRIBUTION_TYPE;
  countryName: string;
  cseg5: string;
  currencySymbol: string;
  entityName: string;
  error: string;
  networkMemberLogoUrl: string;
  networkMemberText: string;
  paymentId: string;
  redirectLink: string;
  status: PaymentStatus;
  taxDeduction: boolean;
  wasLoggedIn: boolean;
  shouldDisplayBankInstructions: boolean;
  fundNumber: string;
  recurrencePattern: RECURRENCE_PATTERN;
  startDate: string;
  endDate: string;
  subscriptionId: string;
  fundName: string;
  anonymous: boolean;
  contributionPurpose: string;
  fundType: FundTypes;
  country: string;
  networkMemberName: string;

  constructor(paymentData?: any, isSwiss?: boolean, isTol?: boolean) {
    if (!paymentData) return;
    this.amount = paymentData.amount;
    this.balance = paymentData.balance;
    this.contributionType = paymentData.contributionType;
    if (paymentData.countryName || paymentData.country) this.setCountryDetails(paymentData);
    this.cseg5 = paymentData.cseg5;
    this.fundNumber = paymentData.fundNumber;
    this.currencySymbol = paymentData.currencySymbol;
    this.entityName = paymentData.entityName;
    this.error = paymentData.error;
    this.paymentId = paymentData.paymentId;
    this.redirectLink = paymentData.redirectLink || paymentData.link;
    if (this.redirectLink) this.wasLoggedIn = this.redirectLink.includes(Urls.APP);
    this.status = paymentData.status;
    this.taxDeduction = [true, 'true'].includes(paymentData.taxDeduction) && (isSwiss || isTol);
    if (this.taxDeduction) this.setNetworkMemberText();
    this.shouldDisplayBankInstructions =
      (!this.taxDeduction || isTol || (isSwiss && this.taxDeduction)) &&
      [CONTRIBUTION_TYPE.BANK_TRANSFER_OFFLINE, CONTRIBUTION_TYPE.DONOR_ADVISED_FUND].includes(this.contributionType);
    this.recurrencePattern = paymentData.recurrencePattern;
    this.startDate = paymentData.startDate;
    this.endDate = paymentData.endDate;
    this.subscriptionId = paymentData.subscriptionId;
    this.fundName = paymentData.fundName;
    this.anonymous = paymentData.anonymous === 'true' ? true : false;
    this.contributionPurpose = paymentData.contributionPurpose;
    this.fundType = StorageHelper.getTargetFundType();
    this.country = paymentData.country;
    this.networkMemberName = paymentData.networkMemberName;
  }

  setCountryDetails(paymentData: any): void {
    this.countryName = paymentData.countryName || paymentData.country;
    this.networkMemberLogoUrl = paymentData.networkMemberLogo;
  }

  setNetworkMemberText(): void {
    switch (this.countryName) {
      case COUNTRY_NAMES.NEW_ZEALAND:
        this.networkMemberText = 'donate.contribution.confirmation.new_zealand';
        break;
      case COUNTRY_NAMES.AUSTRALIA:
        this.networkMemberText = 'donate.contribution.confirmation.australia';
        break;
      case COUNTRY_NAMES.UNITED_KINGDOM:
        this.networkMemberText = 'donate.contribution.confirmation.united_kingdom';
        break;
      case COUNTRY_NAMES.NETHERLANDS:
        this.networkMemberText = 'donate.contribution.confirmation.netherlands';
        break;
      case COUNTRY_NAMES.CROATIA:
        this.networkMemberText = 'donate.contribution.confirmation.croatia';
        break;
      case COUNTRY_NAMES.PUERTO_RICO:
        this.networkMemberText = 'donate.contribution.confirmation.puerto_rico';
        break;
      case COUNTRY_NAMES.ROMANIA:
        this.networkMemberText = 'donate.contribution.confirmation.puerto_rico';
        break;
    }
  }
}

export interface PaymentSessionResponse {
  stripeSessionId: string;
  cseg5: string;
}
